<svelte:options accessors />

<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';

  import IconClose from '@/comps-sdk/components/icon/close.svelte';

  export let title = '';
  export let message = '';

  // 支持图片
  export let image = '';
  export let imageWidth = '120';
  export let imageHeight = '120';

  export let showClose = false;
  export let showCancelButton = true;
  export let cancelButtonText = '取消';
  export let showConfirmButton = true;
  export let confirmButtonText = '确定';
  export let resolve: any = () => {};
  export let reject: any = () => {};

  let visible = false;

  const dispatch = createEventDispatcher();

  const handleAction = (action: string) => {
    dispatch(action);
    close();

    if (action === 'confirm') {
      resolve?.();
    } else {
      reject?.();
    }
  };

  export const close = () => {
    visible = false;
  };

  export const open = () => {
    visible = true;
  };
</script>

{#if visible}
  <div class="dialog-v-overlay" role="button" tabindex="0" transition:fade />
  <div class="dialog-v" transition:fade>
    {#if showClose}
      <div
        class="dialog-v-close"
        tabindex="0"
        role="button"
        on:click={() => {
          handleAction('cancel');
        }}
        on:keyup={() => {}}
      >
        <IconClose />
      </div>
    {/if}
    {#if title}
      <div class="dialog-v-header">{title}</div>
    {/if}
    <div class="dialog-v-content" class:dialog-v-content-has-title={!!title}>
      {#if message}
        <div class="dialog-v-message">
          {message}
        </div>
      {/if}
      {#if image}
        <img class="dialog-v-image" src={image} alt="" width={imageWidth} height={imageHeight} />
      {/if}
    </div>
    <div class="dialog-v-footer">
      {#if showCancelButton}
        <button
          class="dialog-v-button dialog-v-button-cancel"
          on:click={() => {
            handleAction('cancel');
          }}
        >
          <div class="dialog-v-button-content">{cancelButtonText}</div>
        </button>
      {/if}
      {#if showConfirmButton}
        <button
          class="dialog-v-button dialog-v-button-confirm"
          on:click={() => {
            handleAction('confirm');
          }}><div class="dialog-v-button-content">{confirmButtonText}</div></button
        >
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  .dialog-v-overlay {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .dialog-v {
    position: fixed;
    z-index: 1001;
    top: 45%;
    left: 50%;
    width: 320px;
    font-size: 16px;
    background-color: #fff;
    border-radius: 16px;
    transform: translate3d(-50%, -50%, 0);
    backface-visibility: hidden;
    color: black;

    .dialog-v-close {
      position: absolute;
      width: 30px;
      height: 30px;
      top: -45px;
      right: 0px;
      color: #ffffff;
    }

    .dialog-v-header {
      padding-top: 26px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
    }

    .dialog-v-content {
      &:global(.dialog-v-message-has-title) {
        padding-top: 8px;
        color: #646566;
      }
    }

    .dialog-v-image {
      display: block;
      margin: 10px auto;
    }

    .dialog-v-message {
      flex: 1;
      max-height: 60vh;
      padding: 26px 24px;
      overflow-y: auto;
      font-size: 14px;
      line-height: 20px;
      white-space: pre-wrap;
      text-align: center;
      word-wrap: break-word;
    }

    .dialog-v-footer {
      display: flex;
      overflow: hidden;
      user-select: none;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;

      .dialog-v-button {
        color: #323233;
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        height: 48px;
        margin: 0;
        padding: 0;
        line-height: 1.2;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
        background-color: #fff;
        border: 1px solid #ebedf0;
        flex: 1;
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          background-color: #000;
          border: inherit;
          border-color: #000;
          border-radius: inherit;
          transform: translate(-50%, -50%);
          opacity: 0;
          content: ' ';
        }
        &.dialog-v-button-confirm {
          color: #ff5722;
        }
        .dialog-v-button-content {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
        }
      }
    }
  }
</style>
